import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { loggedUser } from 'app/store/login/logged-user/logged-user.selectors';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { UserOutput } from 'core/http/root';
import { ownedError } from 'core/utils/owned-error';
import { selectFirst } from 'core/utils/rx-common';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Uuid } from 'shared/common/types';

@Injectable()
export class UserService {
  constructor(private http: HttpClient, private store$: Store) {}

  getUser(userId: Uuid): Observable<UserOutput> {
    return this.store$.pipe(
      selectFirst(loggedUser),
      switchMap((user) => {
        if (!(user && user.accessToken)) {
          throw ownedError(new Error('Access token is missing'), 'authentication');
        }

        return this.http.get<UserOutput>(apiUrl(`/auth/user/${userId}`), {
          headers: {
            'Authorization': `Bearer ${user.accessToken}`,
            'Content-Type': 'application/json',
          },
        });
      }),
    );
  }
}
